import { render, staticRenderFns } from "./PostSubsidiesNumber.vue?vue&type=template&id=4b506a2d&scoped=true&"
import script from "./PostSubsidiesNumber.vue?vue&type=script&lang=js&"
export * from "./PostSubsidiesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b506a2d",
  null
  
)

export default component.exports